<!-- Main menu with categories -->
<ion-menu contentId="main-content" menuId="main-menu" id="main-menu">
    <ion-content>
        <div class="mx-3 h-100">
            <div
                class="h-100 d-flex flex-column justify-content-between align-items-stretch"
                *ngIf="!menuCategorySelected; else showMenuSubCategory"
            >
                <!-- Logo -->
                <div>
                    <ion-menu-toggle>
                        <a routerLink="/home" class="d-flex w-100 justify-content-center text-decoration-none" routerDirection="root">
                            <img [ngSrc]="'assets/images/logo-' + platform + '.svg'" alt="Avrazya Logo" [width]="150" [height]="50" />
                        </a>
                    </ion-menu-toggle>
                    <div class="d-flex justify-content-start align-items-start flex-column gap-1 mt-3">
                        <ion-menu-toggle>
                            <a class="menu-link" routerLink="/discover">
                                <span class="bi bi-play-btn"></span>
                                {{ "Discover" | translate }}
                            </a>
                        </ion-menu-toggle>
                        <a class="menu-link" routerLink="/platform">
                            <span class="bi bi-shuffle"></span>
                            {{ "Change platform" | translate }}
                        </a>
                        <div class="w-100">
                            <div class="menu-link"><span class="bi bi-tags"></span> {{ "All categories" | translate }}</div>
                            <app-header-category-list
                                [categories]="categories"
                                (selectedCategory)="menuSelectCategory($event)"
                            ></app-header-category-list>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <ion-menu-toggle>
                        <a class="menu-link" routerLink="/settings"
                            ><span class="bi bi-gear-wide-connected"></span> {{ "Settings" | translate }}</a
                        >
                    </ion-menu-toggle>
                    <ion-menu-toggle>
                        <a class="menu-link" routerLink="/support"><span class="bi bi-info-circle"></span> {{ "Support" | translate }}</a>
                    </ion-menu-toggle>
                    <p class="text-center mt-4 menu-copyright d-lg-none">
                        &copy; 2023 - {{ currentYear }} <strong>Avrazya</strong><br />
                        v{{ version }}
                    </p>
                </div>
            </div>
            <ng-template #showMenuSubCategory>
                <div class="w-100 m-x">
                    <div (click)="menuCategoryGoBack()" class="clickable">
                        <span class="bi bi-chevron-left"></span>
                        {{ "Back" | translate }}
                    </div>
                    <div class="pt-3">
                        <div class="menu-link d-flex justify-content-between align-items-center">
                            <div class="d-flex justify-content-start align-items-center">
                                <span class="bi bi-tag"></span>{{ menuCategorySelected.name }}
                            </div>
                            <ion-menu-toggle>
                                <a routerLink="/search" [queryParams]="{ category: menuCategorySelected.id }" class="see-all">{{
                                    "View all" | translate
                                }}</a>
                            </ion-menu-toggle>
                        </div>
                    </div>
                    <app-header-category-list
                        [categories]="childrenCategories"
                        (selectedCategory)="menuSelectCategory($event)"
                    ></app-header-category-list>
                </div>
            </ng-template>
        </div>
    </ion-content>
</ion-menu>

<!-- Main Header (desktop) -->
<div class="container d-none d-lg-block" id="main-desktop-header">
    <div class="row my-2 align-items-center">
        <div class="col-4">
            <!-- Logo -->
            <div class="d-flex justify-content-start align-items-center gap-2">
                <a routerLink="/home" class="text-decoration-none" routerDirection="root">
                    <img [ngSrc]="'assets/images/logo-' + platform + '.svg'" alt="Avrazya Logo" [width]="200" [height]="66" />
                </a>
            </div>
            <div class="d-flex gap-3 justify-content-start align-items-center">
                <div>
                    <a href="#" class="ps-0" (click)="openCategoryMenu($event)">
                        <i class="bi bi-list"></i>
                        {{ "All categories" | translate }}
                    </a>
                </div>
                <a routerLink="/platform" class="d-inline-flex gap-1 platform-selector btn btn-sm btn-outline-primary">
                    <i class="ti ti-switch-3"></i> {{ platform | translate }}
                </a>
                <!--        <div class="horizontal-menu-item"><a routerLink="/home" routerLinkActive="active">{{ 'Home'|translate }}</a></div>-->
                <!-- <div *ngFor="let category of promotedCategories">
                    <a routerLink="/search" [queryParams]="{ category: category.id }"
                        [class.active]="isActive(category)">{{
                        category.name }}</a>
                </div> -->
            </div>
        </div>
        <div class="col-4">
            <div class="search-form-container pb-2">
                <app-search-form [searchForm]="searchForm"></app-search-form>
            </div>
        </div>
        <div class="col-4 d-flex flex-column justify-content-center align-items-center gap-3">
            <div class="d-flex gap-3 align-items-center justify-content-end w-100">
                <a routerLink="/discover" [attr.title]="'Discover' | translate">
                    <i class="icon-size ti ti-player-play"></i>
                </a>
                <a routerLink="/contact">
                    <i class="icon-size ti ti-headset"></i>
                </a>
                <a routerLink="/faq" *ngIf="faqEnabled" [attr.title]="'Help Center' | translate">
                    <i class="icon-size ti ti-help"></i>
                </a>
                <a href="#" (click)="openSettingsModal($event)" type="button">
                    <i class="icon-size ti ti-language"></i>
                </a>
                <a href="#" (click)="openSettingsModal($event)" type="button">
                    <i class="icon-size ti ti-coin"></i>
                </a>
                <a href="#" (click)="openSettingsModal($event)" type="button">{{ activeMarket?.displayName }}</a>
                <!-- Shopping Cart -->
                <a routerLink="/cart" class="text-decoration-none position-relative">
                    <i class="icon-size ti ti-shopping-cart"></i>
                    <span class="sc-pill" *ngIf="shoppingCartLineCount > 0">{{ shoppingCartLineCount }}</span>
                </a>
            </div>
            <div class="d-flex gap-3 align-items-center justify-content-end gap-3 w-100">
                <a routerLink="/create-offer" class="btn btn-sm btn-danger d-flex align-items-center gap-1">
                    <i class="ti ti-target-arrow"></i> {{ "Publish for free" | translate }}
                </a>
                <div>
                    <a routerLink="/signup" *ngIf="!user">
                        {{ "Sign in / Register" | translate }}
                        <span class="ti ti-user icon-size" *ngIf="!user"></span>
                    </a>
                    <a
                        class="mobile-footer-link"
                        routerLink="/profile"
                        routerLinkActive="active"
                        class="d-flex align-items-center gap-1"
                        *ngIf="user"
                    >
                        {{ user.fullname }}
                        <app-picture *ngIf="user.picture" [picture]="user.picture" size="25" format="circle"></app-picture>
                        <span class="ti ti-user-check icon-size" *ngIf="user && !user.picture"></span>
                    </a>
                    <ng-container *ngIf="loginLoading">
                        <div>
                            <ion-spinner></ion-spinner>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Mobile Header -->
<div class="d-flex d-lg-none justify-content-between p-2 align-items-center" id="main-header-mobile">
    <div class="d-flex justify-content-start align-items-center gap-2">
        <a href="#" class="d-flex align-items-center" (click)="openCategoryMenu($event)">
            <i class="ti ti-menu-2 fs-2"></i>
        </a>
        <a routerLink="/home">
            <img [src]="'assets/images/logo-' + platform + '.svg'" alt="Avrazya Logo" [width]="120" [height]="40" />
        </a>
    </div>
    <div class="d-flex justify-content-center align-items-center">
        <app-search-form [searchForm]="searchForm" [isMobile]="true"></app-search-form>
    </div>
    <!-- <div class="d-flex justify-content-end align-items-center gap-3 pe-2">
        <a href="#" (click)="openSettingsModal($event)" type="button">
            <span class="fs-4 bi bi-globe-europe-africa"></span>
        </a>
        <a routerLink="/cart" class="text-decoration-none position-relative">
            <i class="fs-4 ml-2 bi bi-cart4"></i>
            <span class="sc-pill" *ngIf="shoppingCartLineCount > 0">{{ shoppingCartLineCount }}</span>
        </a>
    </div> -->
</div>
